export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        const storageKey = 'searchItems';
        ele.addEventListener('click', handleAddFragmentToSearchUrl);
        save(searchResultFromDom(ele));
        radio('filter-and-search-changed').subscribe(e => {
            save(searchResultFromJson(e));
        });

        function handleAddFragmentToSearchUrl(evt) {
            const linkEle = evt.target.closest('a');
            if (linkEle) {
                const searchLink = new URL(document.baseURI);
                searchLink.hash = linkEle.id;
                const searchResults = load();
                if (searchResults) {
                    searchResults.search = searchLink.href;
                    save(searchResults);
                }
            }
        }

        function searchResultFromJson(data) {
            return {
                next:
                    data.nextResult &&
                    data.nextResult.url.replace('.html', '.json'),
                prev:
                    data.prevResult &&
                    data.prevResult.url.replace('.html', '.json'),
                search: window.location.href,
                urls: data.displaySearchResults
                    .filter(e => !e.isBanner)
                    .map(e => e.adUrl),
            };
        }

        function searchResultFromDom(ele) {
            const nextEle = ele.querySelector('[rel=next]');
            const prevEle = ele.querySelector('[rel=prev]');
            return {
                next: nextEle && nextEle.href.replace('.html', '.json'),
                prev: prevEle && prevEle.href.replace('.html', '.json'),
                search: window.location.href,
                urls: [
                    ...ele.querySelectorAll('[data-search-resultitem]'),
                ].map(e => e.getAttribute('href')),
            };
        }

        function load() {
            try {
                const data = JSON.parse(
                    window.sessionStorage.getItem(storageKey)
                );
                return data && data.urls && data.search ? data : null;
            } catch (e) {
                return null;
            } // ignore session storage missing or incognito mode
        }

        function save(data) {
            try {
                window.sessionStorage.setItem(storageKey, JSON.stringify(data));
            } catch (e) {} // ignore session storage missing or incognito mode
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/adPagingCapture.js